module.exports = __webpack_public_path__ + "static/SouthAmerican-662716311910b9d18390d1ec455a954a.png";